export enum Products {
    COMMON = 'common',
    LOAN = 'loan',
    LOAN_INSURANCE = 'loan_insurance',
    LOAN_REFINANCING = 'loan_refinancing',
    TRAVEL = 'travel',
    HEALTH = 'health',
    HEALTH_COMPARATOR = 'health_comparator',
    HOME = 'home',
    DOG_CAT = 'dog_cat',
    DEATH_INSURANCE = 'death_insurance',
    INSURANCES = 'assurances',
}
